export const setAlertMessage = (alertMessage) => (dispatch) => {
  if (alertMessage) dispatch({ type: 'ALERT_MESSAGE', payload: alertMessage })
}
